import { EnquiryCustomer, EnquiryNpsSchedule, EnquiryRawMaterialGrade, EnquirySms, EnquiyNormGrade } from "./enquiry.model";
import { BonusScheme, MarketFamily, OfferScheme, OfferValidity } from "./headerParametersValues.model";

export class EnquiryByEnquiryNo{
    enquiry?:{
        salesPerson?: string;
        salesOffice?: string;
        customer?: EnquiryCustomer;
        unitSystem?: string;
        currency?: string;
        dueDate?: number;
        optionDate?: number;
        creationDate?: number;
        lastRevisionDate?: number;
        projectName?: string;
        alloySurcharge?: boolean;
        orderReason?: string;
        applicableNorms?: string;
        normGrades?: EnquiyNormGrade[];
        marketingGrade?: string;
        rawMaterialGrade?: EnquiryRawMaterialGrade;
        testCategory?: string;
        od?: number;
        odUom?: string;
        wt?: number;
        wtUom?: string;
        id?: number;
        idUom?: string;
        npsSchedule?: EnquiryNpsSchedule;
        sms?: EnquirySms;
        totalWeight?: number;
        totalWeightUom?: string;
        remark?: string;
        offerStatus?: string;
        feasibilityStatus?: string;
        costsStatus?: string;
        deliveryStatus?: string;
        marketFamily?: MarketFamily;
        customerEnquiryNo?: string;
        mstOfferStatus?:string;
        length?: number;
        lengthUom?: string;
        isTotalWeightEditable?: boolean;
        offerValidity?: OfferValidity;
        offerScheme?: OfferScheme;
        bonusScheme?: BonusScheme;
        customerRequestDate?: number | null;
        hasCustomerSpecialRequirements?: boolean;
    }
}
